export default __webpack_public_path__ + "static/media/Zone-3.67ee540a.jpg";